import { render, staticRenderFns } from "./ServiceLogin.vue?vue&type=template&id=6bc55d0a&scoped=true"
import script from "./ServiceLogin.vue?vue&type=script&lang=js"
export * from "./ServiceLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc55d0a",
  null
  
)

export default component.exports